/* Turn status surfaces (<RetryingNotice>, <FailedTurn>) — shared by the
 * dashboard (imports this file) and the widget (inlines it into its shadow
 * DOM). Colours follow the chat-content contract: host-provided --nw-* vars
 * with dark fallbacks, so light and dark both work without host overrides.
 * Keep every surface colour in a token; no hard-coded fills. */

/* --- retrying ------------------------------------------------------------- */
.nw-turn-retrying {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0 6px;
  padding: 6px 11px;
  border-radius: 10px;
  background: var(--nw-bg-subtle, rgba(255, 255, 255, 0.04));
  border: 1px solid var(--nw-border, rgba(255, 255, 255, 0.12));
  color: var(--nw-text-secondary, #9aa7b8);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.005em;
  animation: nw-turn-in 0.2s ease;
}
.nw-turn-spinner {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--nw-border, rgba(255, 255, 255, 0.12));
  border-top-color: var(--nw-accent, #5b93e8);
  animation: nw-turn-spin 0.7s linear infinite;
}

/* --- failed --------------------------------------------------------------- */
.nw-turn-failed {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: 100%;
  margin: 6px 0 2px;
  padding: 10px 12px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--nw-danger, #d9605c) 9%, transparent);
  border: 1px solid color-mix(in srgb, var(--nw-danger, #d9605c) 35%, transparent);
  color: var(--nw-text, #e7ecf3);
  font-size: 13px;
  line-height: 1.4;
  animation: nw-turn-in 0.2s ease;
}
.nw-turn-failed-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  color: var(--nw-danger, #d9605c);
}
.nw-turn-failed-icon svg { width: 100%; height: 100%; display: block; }
.nw-turn-failed-body { flex: 1 1 auto; min-width: 0; }
.nw-turn-failed-title { font-weight: 600; }
.nw-turn-failed-detail {
  margin-top: 2px;
  color: var(--nw-text-secondary, #9aa7b8);
  font-size: 12.5px;
  overflow-wrap: anywhere;
}
.nw-turn-retry {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: center;
  padding: 6px 11px;
  border-radius: 9px;
  border: 1px solid var(--nw-border, rgba(255, 255, 255, 0.12));
  background: var(--nw-bg, transparent);
  color: var(--nw-text, #e7ecf3);
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.nw-turn-retry svg { width: 13px; height: 13px; }
.nw-turn-retry:hover:not(:disabled) {
  border-color: var(--nw-accent, #5b93e8);
  background: color-mix(in srgb, var(--nw-accent, #5b93e8) 10%, transparent);
}
.nw-turn-retry:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--nw-accent, #5b93e8) 25%, transparent);
}
.nw-turn-retry:disabled { opacity: 0.55; cursor: not-allowed; }

@media (max-width: 480px) {
  .nw-turn-failed { flex-wrap: wrap; }
  .nw-turn-retry { margin-left: 28px; }
}

@keyframes nw-turn-in {
  from { opacity: 0; transform: translateY(-2px); }
  to   { opacity: 1; transform: none; }
}
@keyframes nw-turn-spin { to { transform: rotate(360deg); } }

@media (prefers-reduced-motion: reduce) {
  .nw-turn-retrying, .nw-turn-failed { animation: none; }
  .nw-turn-spinner { animation-duration: 1.6s; }
}
